import { render } from "./Team_partner.vue?vue&type=template&id=a24ab0d2&scoped=true"
import script from "./Team_partner.vue?vue&type=script&lang=js"
export * from "./Team_partner.vue?vue&type=script&lang=js"

import "./Team_partner.vue?vue&type=style&index=0&id=a24ab0d2&scoped=true&lang=css"
script.render = render
script.__scopeId = "data-v-a24ab0d2"

export default script